// src/mixins/toastMixin.js

export default {
  data() {},
  methods: {
    makeToast(title, contents, append = false, variant = 'info', autoHideDelay = 3000) {
      // 새로운 방식: 객체로 전달받은 경우
      if (typeof title === 'object' && title !== null) {
        const options = title;
        this.$bvToast.toast(`${options.contents}`, {
          title: options.title,
          toaster: 'b-toaster-bottom-right',
          solid: true,
          appendToast: options.append ?? false,
          autoHideDelay: options.autoHideDelay ?? 3000,
          variant: options.variant ?? 'info',
          toastClass: 'custom-toast'
        });
      } else {
        // legacy: 기존 방식: 개별 파라미터로 전달받은 경우 (하위 호환성 유지)
        // 객체 파라미터로 전달하는 방식이 더 확장성 있어서 위에 방식을 추가한 것.
        // 기존에 쓰이던 곳이 많아서 보류
        this.$bvToast.toast(`${contents}`, {
          title: title,
          toaster: 'b-toaster-bottom-right',
          solid: true,
          appendToast: append,
          autoHideDelay: autoHideDelay,
          variant: variant,
          toastClass: 'custom-toast'
        });
      }
    }
  },
  created() {
    this.$EventBus.$on('make-toast', this.makeToast);
  }
};
